/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T11:12:57.647
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getChannelEditInit,
	getChannelView
} from '@api/rentmanage/Channel';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getChannelEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChannelEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getChannelView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChannelView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
